import { useOrderFulfillmentEvents } from './useOrderFulfillmentEvents'

/** Mount inside ReactQueryProvider, for pharmacists only. Renders nothing. */
export function OrderFulfillmentEventsListener() {
  useOrderFulfillmentEvents()
  return null
}
